import { Button, Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { useState, useEffect } from 'react';

import { translate } from '@portal/services/i18n';
import IdwallSDK from '../IdwallSDK/IdwallSDK';

import { DocumentType } from '@portal/models/enumerators/onboarding';
import useReduxState from '@portal/hooks/useReduxState';

interface IdwallUploadModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onComplete: (token: string) => void;
  documentType: DocumentType;
}

const IdwallUploadModal = ({
  isOpen,
  onCancel,
  onComplete,
}: IdwallUploadModalProps) => {
  const [idwallToken, setIdwallToken] = useState<string | undefined>();
  const { loadUploadImages } = useReduxState().loading;

  useEffect(() => {
    if (!isOpen) {
      setIdwallToken(undefined);
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (idwallToken) {
      onComplete(idwallToken);
    }
  };

  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={true}
      onCancel={onCancel}
      className="idwall-modal__message-modal"
    >
      <div className="idwall-modal__content">
        <IdwallSDK setToken={setIdwallToken} />
      </div>

      <Row className="idwall-modal__message-modal__button" justify="center">
        <Button
          type="primary"
          disabled={!idwallToken}
          onClick={handleSubmit}
          loading={loadUploadImages}
        >
          {translate('PAGES.PENDING_DOCUMENTS.MODAL.SUBMIT')}
        </Button>
      </Row>
    </Modal>
  );
};

export default IdwallUploadModal;
